import CardDesignerAssetGroupPanel from './CardDesignerAssetGroupPanel';

export default CardDesignerAssetGroupPanel;
